import { getPageNumberFromMap } from "~/components/plp-page/hooks/use-request-handler/helpers/get-page-number-from-map";
import { getFilterValuesForRequest } from "~/helpers/get-filter-values-for-request";
import { IUseRequestHandlerActionsKind } from "~/types/products-request-handler";

import { IHandleLoadButton } from "../types";

export const handleLoadPrevious = async ({
  getMoreItems,
  q,
  efq,
  brUid2,
  brRefUrl,
  appliedFilters,
  isShopFilter,
  currentStore,
  activeSortingParam,
  pageSize,
  itemsMap,
  currentPageNumber,
  productsMarkerId,
  setProductsMarkerId,
  locale,
  dispatchRequest,
}: IHandleLoadButton): Promise<void> => {
  if (currentPageNumber.current <= 1) {
    return;
  }
  if (productsMarkerId) {
    setProductsMarkerId(null);
  }
  const derivedPageNumber = getPageNumberFromMap(itemsMap);
  const filterValues = getFilterValuesForRequest(
    appliedFilters,
    isShopFilter,
    currentStore?.id,
  );

  dispatchRequest({
    type: IUseRequestHandlerActionsKind.SET_DIRECTION,
    payload: { direction: "previous" },
  });

  getMoreItems({
    variables: {
      q: q ?? "",
      efq,
      start: (derivedPageNumber - 2) * pageSize,
      rows: pageSize,
      shouldConcat: true,
      fq: filterValues,
      sort: activeSortingParam,
      locale,
      brUid2,
      brRefUrl,
    },
  });
};
